/* -------------------------------------------------------------------------- */
/*                            External Dependencies                           */
/* -------------------------------------------------------------------------- */
import styled from 'styled-components';

export const LogoContainer = styled.div`
	margin-bottom: 24px;
`;
